import get from 'lodash/get';

import { SET_EDITED_BASKET_V3, CLEAR_EDITED_BASKET_V3 } from 'lib/constants/v3Actions';

const initialState = {
  isLoaded: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_EDITED_BASKET_V3:
      return {
        ...state,
        isLoaded: true,
      };
    case CLEAR_EDITED_BASKET_V3:
      return initialState;
    default:
      return state;
  }
};

export const selectBasketIsLoaded = state => get(state, 'isLoaded', false);
